module.exports = __webpack_public_path__ + "static/media/logotipo.1eeb09af.svg";